<template>
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10">
      <h2>Dodaj tag śledzenia</h2>
      <ol class="breadcrumb">
        <li>
          <router-link to="/">Home</router-link>
        </li>
        <li>
          <router-link to="/tracking-tags">Tagi - Ecommerce</router-link>
        </li>
        <li class="active">
          <strong>Dodaj tag</strong>
        </li>
      </ol>
    </div>
  </div>

  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="row">
      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-title" @click="isMainOpen = !isMainOpen">
            <h5>Nowy tag śledzenia</h5>
            <span :class="chevronMainClass" class="ibox-toggle"></span>
          </div>
          <div class="ibox-content" v-show="isMainOpen">
            <form @submit.prevent="create" class="form-horizontal">
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="col-sm-3 control-label">Nazwa *</label>
                    <div class="col-sm-9">
                      <input
                        type="text"
                        class="form-control"
                        v-model="tagObj.name"
                        placeholder="Nazwa tagu"
                        required
                      />
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="col-sm-3 control-label">Typ *</label>
                    <div class="col-sm-9">
                      <Multiselect
                        v-model="tagObj.type"
                        :options="typeOptions"
                        :searchable="true"
                        :create-option="false"
                        placeholder="Wybierz typ"
                        track-by="value"
                        label="label"
                        mode="single"
                        required
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="col-sm-3 control-label"
                      >Identyfikator *</label
                    >
                    <div class="col-sm-9">
                      <input
                        type="text"
                        class="form-control"
                        v-model="tagObj.identifier"
                        placeholder="np. G-XXXXXXXXXX"
                        required
                      />
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="col-sm-3 control-label">Lokalizacja *</label>
                    <div class="col-sm-9">
                      <Multiselect
                        v-model="tagObj.location"
                        :options="locationOptions"
                        :searchable="true"
                        :create-option="false"
                        placeholder="Wybierz lokalizację"
                        track-by="value"
                        label="label"
                        mode="single"
                        required
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="col-sm-3 control-label"
                      >Kod śledzenia *</label
                    >
                    <div class="col-sm-9">
                      <textarea
                        class="form-control"
                        v-model="tagObj.code_snippet"
                        rows="8"
                        placeholder="Wklej pełny kod śledzenia..."
                        required
                      ></textarea>
                      <small class="form-text text-muted">
                        Wklej pełny kod śledzenia zawierający identyfikator
                      </small>
                    </div>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <div class="col-sm-offset-2 col-sm-10">
                  <div class="checkbox">
                    <label>
                      <input type="checkbox" v-model="tagObj.is_active" />
                      Tag aktywny
                    </label>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <div class="col-sm-offset-2 col-sm-10">
                  <button
                    v-if="canAddTrackingTag"
                    type="submit"
                    class="btn btn-primary"
                  >
                    <i class="fa fa-save"></i> Zapisz
                  </button>
                  <router-link to="/tracking-tags" class="btn btn-default">
                    <i class="fa fa-times"></i> Anuluj
                  </router-link>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed, watch, onMounted } from "vue";
import { useStore } from "vuex";
import { hasPermission } from "../../permissions";
import { trackingTagPermissionsConst } from "../../constants/tagsConstants";
import Multiselect from "@vueform/multiselect";
import "@vueform/multiselect/themes/default.css";

export default {
  name: "TrackingTagsCreate",
  components: {
    Multiselect,
  },
  setup() {
    const store = useStore();
    const canAddTrackingTag = computed(() =>
      hasPermission(trackingTagPermissionsConst.add)
    );
    const tagObj = ref({
      name: "",
      type: "",
      identifier: "",
      code_snippet: "",
      is_active: true,
      location: "",
    });
    const typeOptions = ref([]);
    const locationOptions = ref([]);
    const showErrors = ref(false);
    const isMainOpen = ref(true);

    const createTrackingTagData = computed(
      () => store.getters.getCreateTrackingTagData
    );
    const trackingTagsTypeOpts = computed(
      () => store.getters.getTrackingTagsTypeOpts
    );
    const trackingTagsLocationOpts = computed(
      () => store.getters.getTrackingTagsLocationOpts
    );

    const create = () => {
      if (!canAddTrackingTag.value) {
        return;
      }
      showErrors.value = true;
      store.dispatch("createTrackingTag", tagObj.value);
    };

    const getOptions = () => {
      store.dispatch("getTrackingTagsTypeOpts");
      store.dispatch("getTrackingTagsLocationOpts");
    };

    watch(
      () => createTrackingTagData.value,
      function (newValue) {
        if (newValue && newValue.status === 201) {
          store.dispatch("showToaster", {
            type: "success",
            content: "Tag śledzenia został dodany",
          });
          // Reset form
          tagObj.value = {
            name: "",
            type: "",
            identifier: "",
            code_snippet: "",
            is_active: true,
            location: "",
          };
          showErrors.value = false;
        } else if (newValue && newValue.status && newValue.status !== 201) {
          var msg = [];
          if (newValue.data) {
            for (const [key, value] of Object.entries(newValue.data)) {
              msg.push(key + ": " + value);
            }
          }
          store.dispatch("showToaster", {
            type: "error",
            content:
              msg.length > 0 ? msg[0] : "Błąd podczas dodawania tagu śledzenia",
          });
        }
      }
    );

    watch(
      () => trackingTagsTypeOpts.value,
      function (newValue) {
        if (newValue) {
          typeOptions.value = [];
          if (newValue.data) {
            newValue.data.data.forEach((item) => {
              typeOptions.value.push({
                value: item.value,
                label: item.name,
              });
            });
          }
        }
      }
    );

    watch(
      () => trackingTagsLocationOpts.value,
      function (newValue) {
        if (newValue) {
          locationOptions.value = [];
          if (newValue.data) {
            newValue.data.data.forEach((item) => {
              locationOptions.value.push({
                value: item.value,
                label: item.name,
              });
            });
          }
        }
      }
    );

    onMounted(() => {
      getOptions();
    });

    return {
      canAddTrackingTag,
      tagObj,
      typeOptions,
      locationOptions,
      showErrors,
      create,
      getOptions,
      isMainOpen,
    };
  },
  computed: {
    chevronMainClass() {
      return this.isMainOpen ? "fa fa-chevron-up" : "fa fa-chevron-down";
    },
  },
};
</script>

<style scoped>
.ibox-title {
  cursor: pointer;
  position: relative;
}

.ibox-toggle {
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  color: #676a6c;
}
</style>
